import '../styling/NewClientDetails.css'
import DashNav3 from '../components/DashNav3';
import backarrow from '../resources/backarrow.png'
import { Link } from "react-router-dom";
import { useState } from "react";
import { useParams } from 'react-router-dom';
import {useAuthContext} from "../hooks/useAuthContext"
import {useClientsContext} from '../hooks/useClientsContext'
import NewClientDetailsList from '../components/NewClientDetailsList';
import API_BASE_URL from '../config.js';

const NewClientDetails = () => {
    const {client, dispatch} = useClientsContext();
    const {user} = useAuthContext();
    const { clientId } = useParams();
    const [error,setError] = useState("")
    const[success,setSuccess] = useState("")
    const[buttonState,setButtonState] = useState("btn btn-error");

    const handleDelete = async () => {
    
        if(!user){
          return
        }
    
        console.log(client)
        const response = await fetch(`${API_BASE_URL}/api/client/${clientId}`, {
          method: "DELETE",
          headers:{
            "Authorization": `Bearer ${user.token}`
          }
        })
    
        const json = await response.json()
    
        if(response.ok){
          dispatch({type: "DELETE_CLIENTS", payload:json})
          setSuccess("Client deleted successfully!")
          setButtonState("btn btn-disabled")
        }
        else{
            setError("An error has occured!")
        }
    
      }

    return ( 
        <div className="newclientdetailscontainer">
            <DashNav3></DashNav3>
            <div className="newclientdetailsright">
            <div className="error2">
            {error && 
            <div className="alert alert-error" id="createclientsuccess">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>Error! {error}</span>
            </div>}
            {success && 
            <div className="alert alert-success" id="createclientsuccess">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>{success}</span>
          </div>}
            </div> 
                <div className="newdetailstop">
                <div className="createtopleft">
                    <Link to="/clients" style={{textDecoration: 'none'}}>
                    <img src={backarrow} alt="" />
                    </Link>
                    <h1 className="text-3xl font-bold">Client Details</h1>
                    </div>
                    <button className={buttonState}   id="newclientsbutton" style={{color:'white'}} onClick={() => handleDelete()}>Delete Client</button>
                </div>
                <hr id="newline1"/>
                <NewClientDetailsList></NewClientDetailsList>
            </div>
        </div>
     );
}
 
export default NewClientDetails;